import React from 'react'
import { Briefcase, ChevronLeft, Lock, Shield, User } from 'react-feather'

interface TabNavigationProps {
  currentStep: number
  setStep: (step: number) => void
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  currentStep,
  setStep
}) => {
  const steps = [
    { id: 1, name: 'Basic Information', icon: <User /> },
    { id: 2, name: 'Verify Email', icon: <Shield /> },
    { id: 3, name: 'Set Password', icon: <Lock /> },
    { id: 4, name: 'Business Details', icon: <Briefcase /> }
  ]

  // Check if we are not on the first step to display the back button
  const showBackButton = currentStep > 1

  return (
    <div className="mb-4 d-flex align-items-center">
      {/* Conditionally render back button */}
      {showBackButton && (
        <ChevronLeft
          size={24}
          className="text-white me-3"
          style={{ cursor: 'pointer' }}
          onClick={() => setStep(currentStep - 1)} // Go to the previous step
        />
      )}

      {/* Tabs Navigation */}
      <div className="d-flex justify-content-between flex-grow-1">
        {steps.map((step) => (
          <button
            key={step.id}
            type="button"
            className={`btn btn-link ${
              currentStep === step.id ? 'text-white' : 'text-white-50'
            }`}
            onClick={() => setStep(step.id)}
            disabled={currentStep !== step.id}
            style={{
              textDecoration: 'none',
              fontSize: '8px',
              padding: '0 4px',
              cursor: currentStep !== step.id ? 'not-allowed' : 'pointer' // Change cursor for disabled tabs
            }}
          >
            <div className="d-flex flex-column align-items-center">
              <div className="mb-1">{step.icon}</div>
              <span>{step.name}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default TabNavigation
